import { MenuItem } from '@amzn/meridian/menu';
import { localize } from './localize';

export default localize(MenuItem, ['children']);
